// extracted by mini-css-extract-plugin
export default {"header":"EVipFranchiseDealerItems-module-header","item":"EVipFranchiseDealerItems-module-item"};